import { C } from "../../styles/theme";
import SecHdr from "../common/SecHdr";
import Avatar from "../common/Avatar";

export default function TeamSection({ members }) {
  const active = (members || []).filter(m => m.status === "active");
  if (!active.length) return null;
  return (
    <div className="section" style={{ background: "#f5f7fb", borderTop: "1px solid #D8E2EE", borderBottom: "1px solid #D8E2EE" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <SecHdr tag="Our Team" title="The People Behind Cyclojet" sub="Experienced professionals leading each vertical with deep domain expertise." />
        <div className="grid-3">
          {active.map(m => (
            <div key={m.id} className="hl card" style={{ padding: "26px 22px", textAlign: "center", background: "#fff", border: "1px solid #D8E2EE" }}>
              <div style={{ display: "flex", justifyContent: "center", marginBottom: 14 }}>
                <Avatar src={m.photo} name={m.name} size={76} border={true} />
              </div>
              <div style={{ fontSize: 15.5, fontWeight: 700, color: C.blue, marginBottom: 4 }}>{m.name}</div>
              <div style={{ fontSize: 12.5, fontWeight: 700, color: "#E8593C", marginBottom: 8 }}>{m.role}</div>
              <div style={{ fontSize: 13, color: "#6A7A8A", lineHeight: 1.7, marginBottom: m.linkedin ? 12 : 0 }}>{m.bio}</div>
              {m.linkedin && <a href={m.linkedin} target="_blank" rel="noreferrer" style={{ fontSize: 12.5, color: "#E8593C", fontWeight: 700, textDecoration: "none", transition: "opacity .15s" }}>LinkedIn</a>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
